var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-field',{attrs:{"label":"ログイン種別の選択"}},[_c('div',{attrs:{"id":"firebaseui-auth-container"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }